import { render, staticRenderFns } from "./PendingNotificationList.vue?vue&type=template&id=32e4e3f2&"
import script from "./PendingNotificationList.vue?vue&type=script&lang=js&"
export * from "./PendingNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports